export { default } from "../[companySlug]/articles/[articleSlug]";
export { getServerSideProps } from "../[companySlug]/articles/[articleSlug]";
